import React from 'react'
import { Link } from 'react-router-dom'
import BannerSlider from './BannerSlider'
import BlogSlider from './BlogSlider'
import BycycleSlider from './BycycleSlider'

function Home () {
  
  return (
    <div>
    <BannerSlider/>
    <div className="banner-tabs">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="tabs">
              <div className="tab-content">
                <div className="tab-pane active" id="cars">
                  <div className="tab-inner">
                    <form>
                      <div className="row">
                        <div className="col-lg-4 col-md-6">
                          <div className="form-group">
                            <label className="fs-14 text-custom-white fw-600">Bicycle Name</label>
                            <input type="text" name="#" className="form-control form-control-custom" placeholder=" Name"/>
                          </div>
                          <div className="row">
                            <div className="col-6">
                              <div className="form-group">
                                <label className="fs-14 text-custom-white fw-600">Gair Type</label>
                                <div className="group-form">
                                  <select className="custom-select form-control form-control-custom">
                                    <option>Economi</option>
                                    <option>Economi</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="form-group">
                                <label className="submit"></label>
                                <div className="group-form">
                                  <select className="custom-select form-control form-control-custom">
                                    <option>Anytime</option>
                                    <option>Morning</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="form-group">
                            <label className="fs-14 text-custom-white fw-600">Brand</label>
                            <input type="text" name="#" className="form-control form-control-custom" placeholder="city, distirct or specific airpot"/>
                          </div>
                          <div className="row">
                            <div className="col-6">
                              <div className="form-group">
                                <label className="fs-14 text-custom-white fw-600">Persona</label>
                                <div className="input-group group-form">
                                  <input type="text" name="#" className="form-control form-control-custom datepickr" placeholder="mm/dd/yy" readOnly/>
                                  <span className="input-group-append"> <i className="far fa-calendar"></i> </span> </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="form-group">
                                <label className="submit"></label>
                                <div className="group-form">
                                  <select className="custom-select form-control form-control-custom">
                                    <option>Anytime</option>
                                    <option>Morning</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-12">
                          <div className="row">
                            <div className="col-6">
                              <div className="form-group">
                                <label className="fs-14 text-custom-white fw-600">Bicycle Type</label>
                                <div className="group-form">
                                  <select className="custom-select form-control form-control-custom">
                                    <option>Hero</option>
                                    <option>Bajaj</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          
                            <div className="col-6">
                              <div className="form-group">
                                <label className="fs-14 text-custom-white fw-600">Promocode</label>
                                <input type="text" name="#" className="form-control form-control-custom" placeholder="type here"/>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="form-group">
                                <label className="fs-14 text-custom-white fw-600">Adults</label>
                                <div className="group-form">
                                  <select className="custom-select form-control form-control-custom">
                                    <option>1</option>
                                    <option>2</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="form-group">
                                <label className="submit"></label>
                                <button className="btn-first btn-submit full-width btn-height">Search</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* <!-- End Banner tabs --> 
    <!-- Start About Us --> */}
    <section className="about-section section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="about-content">
              <h3><span className="text-custom-blue">About</span> Us </h3>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. </p>
              <br/>
              <p> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>
              <br/>
              <br/>
              <Link className="main-btn mt-25 m4" to="#">Learn More <i className="fas fa-arrow-right"></i></Link> </div>
          </div>
          <div className="col-lg-6">
            <div className="about-image clearfix">
              <div className="single-image float-left"> <img src="/tm/react/bycycle/assets/images/about-1.jpg" className="image-fit" alt="img"/> </div>
              <div className="single-image image-tow float-right"> <img src="/tm/react/bycycle/assets/images/about-2.jpg" className="image-fit" alt="img"/> </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* <!-- End About Us --> 
    <!-- Start Our work --> */}
    <section className="work-area bg-light" id="work-area">
      <div className="container">
        <div className="section-header text-center">
          <div className="section-heading">
            <h3 className="text-custom-black">Our <span className="text-custom-blue">Work</span></h3>
            <div className="section-description">
              <p className="text-light-dark">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.</p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="work-filter text-center mt-5" data-aos="fade-up" data-aos-duration="500">
              <ul className="list-inline text-uppercase">
                <li className="list-inline-item active" data-filter="*">All</li>
                <li className="list-inline-item" data-filter=".seo">Seo</li>
                <li className="list-inline-item" data-filter=".webdesign">Webdesign</li>
                <li className="list-inline-item" data-filter=".work">WORK</li>
                <li className="list-inline-item" data-filter=".wordpress">Wordpress</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row mt-4 work-filter-list" data-aos="fade-up" data-aos-duration="500">
          <div className="col-lg-4 col-md-6 webdesign seo">
            <div className="work-filter-item">
              <div className="work-img"> <img src="/tm/react/bycycle/assets/images/work-1.jpg" className="image-fit" alt="img"/> </div>
              <div className="work_detail text-center">
                <p className="mb-2 text-white">Category</p>
                <h4 className="mb-0 text-white">Project Title</h4>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 webdesign wordpress">
            <div className="work-filter-item">
              <div className="work-img"> <img src="/tm/react/bycycle/assets/images/work-2.jpg" className="image-fit" alt="img"/> </div>
              <div className="work_detail text-center">
                <p className="mb-2 text-white">Category</p>
                <h4 className="mb-0 text-white">Project Title</h4>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 work wordpress">
            <div className="work-filter-item">
              <div className="work-img"> <img src="/tm/react/bycycle/assets/images/work-3.jpg" className="image-fit" alt="img"/> </div>
              <div className="work_detail text-center">
                <p className="mb-2 text-white">Category</p>
                <h4 className="mb-0 text-white">Project Title</h4>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 webdesign work">
            <div className="work-filter-item">
              <div className="work-img"> <img src="/tm/react/bycycle/assets/images/work-4.jpg" className="image-fit" alt="img"/> </div>
              <div className="work_detail text-center">
                <p className="mb-2 text-white">Category</p>
                <h4 className="mb-0 text-white">Project Title</h4>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 seo webdesign">
            <div className="work-filter-item">
              <div className="work-img"> <img src="/tm/react/bycycle/assets/images/work-5.jpg" className="image-fit" alt="img"/> </div>
              <div className="work_detail text-center">
                <p className="mb-2 text-white">Category</p>
                <h4 className="mb-0 text-white">Project Title</h4>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 seo webdesign">
            <div className="work-filter-item">
              <div className="work-img"> <img src="/tm/react/bycycle/assets/images/work-6.jpg" className="image-fit" alt="img"/> </div>
              <div className="work_detail text-center">
                <p className="mb-2 text-white">Category</p>
                <h4 className="mb-0 text-white">Project Title</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* <!-- End Our work --> 
    <!-- Start Our Services --> */}
    <section className="ser section-padding">
      <div className="container">
        <div className="section-header text-center">
          <div className="section-heading">
            <h3 className="text-custom-black">Our <span className="text-custom-blue">Services</span></h3>
            <div className="section-description">
              <p className="text-light-dark">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.</p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 col-md-12 mb-5">
            <div className="race-box">
              <div className="race-img"> <img src="/tm/react/bycycle/assets/images/services/service-1.jpg" className="image-fit" alt="img"/> </div>
              <div className="race-data">
                <h2>Lost in Small Streets</h2>
                <ul>
                  <li> <Link to="#"><i className="fas fa-map-marker-alt"></i> Northumberland</Link> </li>
                  <li> <Link to="#"><i className="far fa-clock"></i> 12:00 PM</Link></li>
                </ul>
                <p>Lorem Ipsum is simply dummy text of the printing.</p>
                <Link to="#" className="btn-first btn-submit">Book Now</Link> </div>
            </div>
          </div>
          <div className="col-lg-6  col-md-12 mb-5">
            <div className="race-box">
              <div className="race-img"> <img src="/tm/react/bycycle/assets/images/services/service-2.jpg" className="image-fit" alt="img"/> </div>
              <div className="race-data">
                <h2>Eat & Drink Like a Local</h2>
                <ul>
                  <li> <Link to="#"><i className="fas fa-map-marker-alt"></i> Northumberland</Link> </li>
                  <li> <Link to="#"><i className="far fa-clock"></i> 12:00 PM</Link></li>
                </ul>
                <p>Lorem Ipsum is simply dummy text of the printing.</p>
                <Link to="#" className="btn-first btn-submit">Book Now</Link> </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 ">
            <div className="race-box">
              <div className="race-img"> <img src="/tm/react/bycycle/assets/images/services/service-5.jpg" className="image-fit" alt="img"/> </div>
              <div className="race-data">
                <h2>Nothing Can Stop You</h2>
                <ul>
                  <li> <Link to="#"><i className="fas fa-map-marker-alt"></i> Northumberland</Link> </li>
                  <li> <Link to="#"><i className="far fa-clock"></i> 12:00 PM</Link></li>
                </ul>
                <p>Lorem Ipsum is simply dummy text of the printing.</p>
                <Link to="#" className="btn-first btn-submit">Book Now</Link> </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 ">
            <div className="race-box">
              <div className="race-img"> <img src="/tm/react/bycycle/assets/images/services/service-6.jpg" className="image-fit" alt="img"/> </div>
              <div className="race-data">
                <h2>Best Routes</h2>
                <ul>
                  <li> <Link to="#"><i className="fas fa-map-marker-alt"></i> Northumberland</Link> </li>
                  <li> <Link to="#"><i className="far fa-clock"></i> 12:00 PM</Link></li>
                </ul>
                <p>Lorem Ipsum is simply dummy text of the printing.</p>
                <Link to="#" className="btn-first btn-submit">Book Now</Link> </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* <!-- End Our Service --> 
    <!-- Start gallery --> */}
    <section className="section-padding gallery  bg-light">
      <div className="container">
        <div className="section-header text-center">
          <div className="section-heading">
            <h3 className="text-custom-black">Our <span className="text-custom-blue">Gallry</span></h3>
            <div className="section-description">
              <p className="text-light-dark">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.</p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="tabs filter-gallery">
              <ul className="custom-flex nav nav-tabs mb-xl-40">
                <li className="nav-item"> <Link className="nav-link active" to="#" value="all" data-filter="*">Show All</Link> </li>
                <li className="nav-item"> <Link className="nav-link" to="#" value="category1" data-filter=".tab-gallery">Brakes</Link> </li>
                <li className="nav-item"> <Link className="nav-link" to="#" value="category2" data-filter=".tab-gallery-1">Suspension</Link> </li>
                <li className="nav-item"> <Link className="nav-link" to="#" data-filter=".tab-gallery-2">Wheels</Link> </li>
                <li className="nav-item"> <Link className="nav-link" to="#" data-filter=".car-gallery">Steering</Link> </li>
              </ul>
            </div>
            <div className="row gallery-grid">
              <div className="col-lg-4 col-md-6 filter-box tab-gallery">
                <div className="gallery-item mb-xl-30"> <Link to="/" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-1.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
              <div className="col-lg-4 col-md-6 filter-box tab-gallery-1">
                <div className="gallery-item mb-xl-30"> <Link to="/" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-2.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
              <div className="col-lg-4 col-md-6 filter-box tab-gallery-2">
                <div className="gallery-item mb-xl-30"> <Link to="/" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-3.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
              <div className="col-lg-4 col-md-6 filter-box car-gallery">
                <div className="gallery-item mb-xl-30"> <Link to="/" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-4.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
              <div className="col-lg-4 col-md-6 filter-box tab-gallery">
                <div className="gallery-item mb-xl-30"> <Link to="/" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-5.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
              <div className="col-lg-4 col-md-6 filter-box tab-gallery-1">
                <div className="gallery-item mb-xl-30"> <Link to="/" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-6.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
              <div className="col-lg-4 col-md-6 filter-box tab-gallery-2">
                <div className="gallery-item mb-xl-30"> <Link to="/" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-7.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
              <div className="col-lg-4 col-md-6 filter-box car-gallery">
                <div className="gallery-item mb-xl-30"> <Link to="/" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-8.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
              <div className="col-lg-4 col-md-6 filter-box tab-gallery">
                <div className="gallery-item mb-xl-30"> <Link to="/" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-9.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
              <div className="col-lg-4 col-md-6 filter-box tab-gallery-1">
                <div className="gallery-item mb-xl-30"> <Link to="/" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-10.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
              <div className="col-lg-4 col-md-6 filter-box tab-gallery-2">
                <div className="gallery-item mb-xl-30"> <Link to="/" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-11.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
              <div className="col-lg-4 col-md-6 filter-box car-gallery">
                <div className="gallery-item mb-xl-30"> <Link to="/" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-12.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* <!-- End gallery --> 
    <!-- Recommended Bicycle --> */}
    <BycycleSlider/>
    {/* <!-- End Bicycle --> 
    <!-- Start Our Team --> */}
    <div className="team-area team-all-seven bg-light-white">
      <div className="section-header text-center ">
        <div className="section-heading">
          <h3 className="text-custom-black">Our <span className="text-custom-blue">Team</span></h3>
          <div className="section-description">
            <p className="text-light-dark">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.</p>
          </div>
        </div>
      </div>
      <div className="team-warp">
        <div className="team-seven">
          <div className="team-style-seven">
            <div className="imgBox-7"> <img src="/tm/react/bycycle/assets/images/team-1.jpg" alt="img" className="full-width"/> </div>
            <div className="details-7">
              <div className="content-7">
                <h3>Member Name <br/>
                  <span>Developer</span></h3>
                <ul>
                  <li><Link to="#"><i className="fab fa-facebook" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fa-brands fa-x-twitter"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-linkedin" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-google-plus" aria-hidden="true"></i></Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="team-style-seven">
            <div className="imgBox-7"> <img src="/tm/react/bycycle/assets/images/team-2.jpg" alt="img" className="full-width"/> </div>
            <div className="details-7">
              <div className="content-7">
                <h3>Member Name <br/>
                  <span>Financer</span></h3>
                <ul>
                  <li><Link to="#"><i className="fab fa-facebook" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fa-brands fa-x-twitter"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-linkedin" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-google-plus" aria-hidden="true"></i></Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="team-style-seven">
            <div className="imgBox-7"> <img src="/tm/react/bycycle/assets/images/team-3.jpg" alt="img" className="full-width"/> </div>
            <div className="details-7">
              <div className="content-7">
                <h3>Member Name <br/>
                  <span>Designer</span></h3>
                <ul>
                  <li><Link to="#"><i className="fab fa-facebook" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fa-brands fa-x-twitter"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-linkedin" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-google-plus" aria-hidden="true"></i></Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="team-style-seven">
            <div className="imgBox-7"> <img src="/tm/react/bycycle/assets/images/agent-4.jpg" alt="img" className="full-width"/> </div>
            <div className="details-7">
              <div className="content-7">
                <h3>Member Name <br/>
                  <span>Developer</span></h3>
                <ul>
                  <li><Link to="#"><i className="fab fa-facebook" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fa-brands fa-x-twitter"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-linkedin" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-google-plus" aria-hidden="true"></i></Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="team-style-seven">
            <div className="imgBox-7"> <img src="/tm/react/bycycle/assets/images/team-4.jpg" alt="img" className="full-width"/> </div>
            <div className="details-7">
              <div className="content-7">
                <h3>Member Name <br/>
                  <span>Market</span></h3>
                <ul>
                  <li><Link to="#"><i className="fab fa-facebook" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fa-brands fa-x-twitter"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-linkedin" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-google-plus" aria-hidden="true"></i></Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="team-style-seven">
            <div className="imgBox-7"> <img src="/tm/react/bycycle/assets/images/agent-2.jpg" alt="img" className="full-width"/> </div>
            <div className="details-7">
              <div className="content-7">
                <h3>Member Name <br/>
                  <span>Developer</span></h3>
                <ul>
                  <li><Link to="#"><i className="fab fa-facebook" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fa-brands fa-x-twitter"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-linkedin" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-google-plus" aria-hidden="true"></i></Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="team-style-seven">
            <div className="imgBox-7"> <img src="/tm/react/bycycle/assets/images/agent-3.jpg" alt="img" className="full-width"/> </div>
            <div className="details-7">
              <div className="content-7">
                <h3>Member Name <br/>
                  <span>Financer</span></h3>
                <ul>
                  <li><Link to="#"><i className="fab fa-facebook" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fa-brands fa-x-twitter"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-linkedin" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-google-plus" aria-hidden="true"></i></Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="team-style-seven">
            <div className="imgBox-7"> <img src="/tm/react/bycycle/assets/images/agent-1.jpg" alt="img" className="full-width"/> </div>
            <div className="details-7">
              <div className="content-7">
                <h3>Member Name <br/>
                  <span>Designer</span></h3>
                <ul>
                  <li><Link to="#"><i className="fab fa-facebook" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fa-brands fa-x-twitter"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-linkedin" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-google-plus" aria-hidden="true"></i></Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="team-style-seven">
            <div className="imgBox-7"> <img src="/tm/react/bycycle/assets/images/agent-5.jpg" alt="img" className="full-width"/> </div>
            <div className="details-7">
              <div className="content-7">
                <h3>Member Name <br/>
                  <span>Developer</span></h3>
                <ul>
                  <li><Link to="#"><i className="fab fa-facebook" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fa-brands fa-x-twitter"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-linkedin" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-google-plus" aria-hidden="true"></i></Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="team-style-seven">
            <div className="imgBox-7"> <img src="/tm/react/bycycle/assets/images/agent-6.jpg" alt="img" className="full-width"/> </div>
            <div className="details-7">
              <div className="content-7">
                <h3>Member Name <br/>
                  <span>Market</span></h3>
                <ul>
                  <li><Link to="#"><i className="fab fa-facebook" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fa-brands fa-x-twitter"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-linkedin" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-google-plus" aria-hidden="true"></i></Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* <!-- End Our Team --> 
    <!-- Start Blog --> */}
    <BlogSlider/>
    </div>
  )
}

export default Home